"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
_moment.default.locale('pt-br');
var WEEKDAY_LABELS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
var _default = exports.default = {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false,
      currentPage: 1
    };
  },
  computed: {
    processedWorks: function processedWorks() {
      var fmt = function fmt(d) {
        return d ? (0, _moment.default)(d).format('HH:mm') : '—';
      };
      return (this.data || []).map(function (item) {
        var start = fmt(item.start);
        var end = fmt(item.end);
        var weekdaysLabel = Array.isArray(item.weekdays) ? item.weekdays.filter(function (n) {
          return Number.isInteger(n) && n >= 0 && n <= 6;
        }).map(function (n) {
          return WEEKDAY_LABELS[n];
        }).join(', ') : '';
        var breaksFmt = Array.isArray(item.breaks) ? item.breaks.map(function (b) {
          var t = (b === null || b === void 0 ? void 0 : b.title) || 'Intervalo';
          var s = fmt(b === null || b === void 0 ? void 0 : b.start);
          var e = fmt(b === null || b === void 0 ? void 0 : b.end);
          return "".concat(t, ": ").concat(s, "\u2013").concat(e);
        }) : [];
        return _objectSpread(_objectSpread({}, item), {}, {
          start: start,
          end: end,
          weekdaysLabel: weekdaysLabel,
          breaksFmt: breaksFmt
        });
      });
    }
  }
};